import { inject, Injector, signal, Signal } from '@angular/core';
import { ExecutableMenuItem, handleRequestError } from '@softline/application';
import { modalFn, translator } from '@softline/ui-core';
import { ScannedQuantitiesModal } from '../dialogs/scanned-quantities-modal/scanned-quantities-modal';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';

export interface ScannedQuantitiesMenuItem {
  item: (order: KommissionsauftragKopf | null | undefined) => ExecutableMenuItem;
  /** True while the dialog is open: pages skip their global Enter/scanner handlers. */
  open: Signal<boolean>;
}

/** `onChanged` fires with the reloaded Kommission when the dialog changed something. */
export function scannedQuantitiesMenuItemFn(options?: {
  onChanged?: (order: KommissionsauftragKopf) => Promise<void> | void;
}): ScannedQuantitiesMenuItem {
  const t = translator();
  const modal = modalFn();
  const injector = inject(Injector);
  const open = signal(false);
  return {
    open,
    item: (order) => ({
      name: 'scanned-quantities',
      title: t('#KOMMISSIONIERUNG.ACTIONS.ERFASSTE_MENGEN')(),
      type: 'execute',
      outlet: 'action',
      icon: 'fa-regular fa-clipboard-list',
      tooltip: true,
      tooltipPosition: 'left',
      canExecute: true,
      visible: !!order && order.mischpalette !== true,
      execute: async () => {
        if (!order || open()) return;
        open.set(true);
        try {
          const result = await modal({
            component: ScannedQuantitiesModal,
            title: t('#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.TITLE')(),
            separateContentSection: true,
            dismiss: true,
            class: 'max-h-[90vh]!',
            data: { idkopfkomm: order.id },
          });
          if (result && result !== 'DISMISSED') await options?.onChanged?.(result);
        } catch (e) {
          handleRequestError(e, injector, { show: true });
        } finally {
          open.set(false);
        }
      },
    }),
  };
}
